module.exports = function getResource(label, vars = []) {
    let resources = {
        storeHoursTitle: 'Heures d’ouverture',
        openUntil: `Ouvert jusqu’à ${vars[0]} aujourd’hui`,
        availableUntil: `Disponible jusqu’à ${vars[0]} aujourd’hui`,
        tempClosed: 'Temporairement fermé',
        tempUnavailable: 'Temporarily Unavailable',
        specialStoreHoursTitle: 'Heures d’ouverture spéciales',
        curbsideHoursTitle: 'Heures du ramassage extérieur',
        specialCurbsideHours: 'Heures spéciales du ramassage extérieur',
        unavailableToday: 'Non disponible aujourd’hui'
    };

    return resources[label];
};
